/**
 * Compact number formatting for stat badges, e.g. 33 -> "33", 7930 -> "7.9k",
 * 668450 -> "668k", 2111681 -> "2.1m". Keeps every counter short so a row of
 * stat pills stays a uniform size regardless of magnitude.
 *
 * - < 1000        : shown in full (33, 701)
 * - 1000..999,999 : thousands with one decimal, "k" (7.9k); no decimal >= 100k (668k)
 * - >= 1,000,000  : millions with one decimal, "m" (2.1m); no decimal >= 100m
 */
export function compactNumber(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';

  const abs = Math.abs(n);
  if (abs < 1000) return String(n);

  const fmt = (v) => (Math.abs(v) >= 100 ? String(Math.round(v)) : v.toFixed(1).replace(/\.0$/, ''));

  if (abs < 1_000_000) return fmt(n / 1000) + 'k';
  if (abs < 1_000_000_000) return fmt(n / 1_000_000) + 'm';
  return fmt(n / 1_000_000_000) + 'b';
}
